import React from 'react'
// import { Link } from 'react-router-dom'
// import { Skills } from './Skills'

export const Navbar = () => {
    return (
        <header>
            <div className="fixed w-full top-0 z-50 bg-[#021227] max-w-screen-xl mb-[rem] mx-auto px-4 py-6">
                <nav className="">
                    <ul style={{ fontFamily: "'Roboto Mono','monospace'" }} className="flex justify-around font-semibold">
                        <li className=""><a href="#skills" className="transition-all hover:text-[#247032]">Skills</a></li>
                        <li className=""><a href="#projects" className="transition-all hover:text-[#247032]">Projects</a></li>
                        <li className=""><a href="#blogs" className="transition-all hover:text-[#247032]">Blogs</a></li>
                        <li className=""><a href="#contact" className="transition-all hover:text-[#247032]">Contact</a></li>
                    </ul>
                </nav>
            </div>

        </header>
    )
}
